import { render, staticRenderFns } from "./swiperVideoFlv.vue?vue&type=template&id=5ff3f827&scoped=true"
import script from "./swiperVideoFlv.vue?vue&type=script&lang=js"
export * from "./swiperVideoFlv.vue?vue&type=script&lang=js"
import style0 from "./swiperVideoFlv.vue?vue&type=style&index=0&id=5ff3f827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff3f827",
  null
  
)

export default component.exports